import React from 'react';
import TeamContactLinkItem from './TeamContactLinkItem';
import { Grid } from '@mui/material';

const TeamRecommendedLinks = ({ onContactLinkButtonClick, isLinkTypeRestricted }) => {
    const items = ['Email', 'Call', 'LinkedIn', 'Website'];

    return (
        <Grid container spacing={1} sx={{ justifyContent: 'flex-start' }}>
            {items.map((item) => {
                const isRestricted = isLinkTypeRestricted ? isLinkTypeRestricted(item) : false;
                return (
                <Grid item xs={6} key={item}> {/* Adjusted to 6 for two items per row */}
                    <TeamContactLinkItem
                        text={item}
                        onClick={() => onContactLinkButtonClick(item)}
                        type={item}
                            disabled={isRestricted}
                    />
                </Grid>
                );
            })}
        </Grid>
    );
};

export default TeamRecommendedLinks;